import refClient from '../../../core/refClient';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => refClient.configs;

export const getDefaultConfigs = (state) => state.config.default;
